// FETCH ALL PROPERTIES FROM IRONING_PACKING_DC DETAILS
export const FETCH_IRONING_PACKING_DC_DETAILS_REQUEST = 'FETCH_IRONING_PACKING_DC_DETAILS_REQUEST';
export const FETCH_IRONING_PACKING_DC_DETAILS_SUCCESS = 'FETCH_IRONING_PACKING_DC_DETAILS_SUCCESS';
export const FETCH_IRONING_PACKING_DC_DETAILS_FAILURE = 'FETCH_IRONING_PACKING_DC_DETAILS_FAILURE';

export const FETCH_IRONING_PACKING_DC_PREVIOUS_GET_LIST_DETAILS_REQUEST = 'FETCH_IRONING_PACKING_DC_PREVIOUS_GET_LIST_DETAILS_REQUEST';
export const FETCH_IRONING_PACKING_DC_PREVIOUS_GET_LIST_DETAILS_SUCCESS = 'FETCH_IRONING_PACKING_DC_PREVIOUS_GET_LIST_DETAILS_SUCCESS';
export const FETCH_IRONING_PACKING_DC_PREVIOUS_GET_LIST_DETAILS_FAILURE = 'FETCH_IRONING_PACKING_DC_PREVIOUS_GET_LIST_DETAILS_FAILURE';

// FETCH ALL PROPERTIES FROM IRONING_PACKING_DC DETAILS
export const FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_REQUEST = 'FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_REQUEST';
export const FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_SUCCESS = 'FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_SUCCESS';
export const FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_FAILURE = 'FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_FAILURE';

export const FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_REQUEST = 'FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_REQUEST';
export const FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_SUCCESS = 'FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_SUCCESS';
export const FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_FAILURE = 'FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_FAILURE';

// FETCH ALL PROPERTIES FROM IRONING_PACKING_DC DETAILS BY ID
export const FETCH_IRONING_PACKING_DC_DETAILS_BY_ID_REQUEST = 'FETCH_IRONING_PACKING_DC_DETAILS_BY_ID_REQUEST';
export const FETCH_IRONING_PACKING_DC_DETAILS_BY_ID_SUCCESS = 'FETCH_IRONING_PACKING_DC_DETAILS_BY_ID_SUCCESS';
export const FETCH_IRONING_PACKING_DC_DETAILS_BY_ID_FAILURE = 'FETCH_IRONING_PACKING_DC_DETAILS_BY_ID_FAILURE';

// CREATE PROPERTIES FOR IRONING_PACKING_DC DETAILS
export const CREATE_IRONING_PACKING_DC_DETAILS_REQUEST = 'CREATE_IRONING_PACKING_DC_DETAILS_REQUEST';
export const CREATE_IRONING_PACKING_DC_DETAILS_SUCCESS = 'CREATE_IRONING_PACKING_DC_DETAILS_SUCCESS';
export const CREATE_IRONING_PACKING_DC_DETAILS_FAILURE = 'CREATE_IRONING_PACKING_DC_DETAILS_FAILURE';

export const CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_REQUEST = 'CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_REQUEST';
export const CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_SUCCESS = 'CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_SUCCESS';
export const CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_FAILURE = 'CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_IRONING_PACKING_DC_DETAILS = 'CREATE_USER_FORM_IRONING_PACKING_DC_DETAILS';

export const CREATE_USER_FORM_IRONING_PACKING_DC_EDIT_QTY = 'CREATE_USER_FORM_IRONING_PACKING_DC_EDIT_QTY';

export const RESET_IRONING_PACKING_DC_EDIT_QTY = 'RESET_IRONING_PACKING_DC_EDIT_QTY';

// UPDATE PROPERTIES FOR IRONING_PACKING_DC DETAILS
export const UPDATE_IRONING_PACKING_DC_DETAILS_REQUEST = 'UPDATE_IRONING_PACKING_DC_DETAILS_REQUEST';
export const UPDATE_IRONING_PACKING_DC_DETAILS_SUCCESS = 'UPDATE_IRONING_PACKING_DC_DETAILS_SUCCESS';
export const UPDATE_IRONING_PACKING_DC_DETAILS_FAILURE = 'UPDATE_IRONING_PACKING_DC_DETAILS_FAILURE';

// FETCH SINGLE IRONING_PACKING_DC_DETAILS
export const FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_REQUEST = 'FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_REQUEST';
export const FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_SUCCESS = 'FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_SUCCESS';
export const FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_FAILURE = 'FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_FAILURE';

// DELETE PROPERTIES FOR IRONING_PACKING_DC DETAILS
export const DELETE_IRONING_PACKING_DC_DETAILS_REQUEST = 'DELETE_IRONING_PACKING_DC_DETAILS_REQUEST';
export const DELETE_IRONING_PACKING_DC_DETAILS_SUCCESS = 'DELETE_IRONING_PACKING_DC_DETAILS_SUCCESS';
export const DELETE_IRONING_PACKING_DC_DETAILS_FAILURE = 'DELETE_IRONING_PACKING_DC_DETAILS_FAILURE';

// USERFORM RESET

export const IRONING_PACKING_DC_DETAILS_USERFORM_RESET = 'IRONING_PACKING_DC_DETAILS_USERFORM_RESET';

//DCNO
export const FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_REQUEST = 'FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_REQUEST';
export const FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_SUCCESS = 'FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_SUCCESS';
export const FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_FAILURE = 'FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_FAILURE';

//GRN NO
export const FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_REQUEST = 'FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_REQUEST';
export const FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_SUCCESS = 'FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_SUCCESS';
export const FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_FAILURE = 'FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_FAILURE';

export const FETCH_IRONING_PACKING_DC_DETAILS_SECOND_GRID_REQUEST = 'FETCH_IRONING_PACKING_DC_DETAILS_SECOND_GRID_REQUEST';
export const FETCH_IRONING_PACKING_DC_DETAILS_SECOND_GRID_SUCCESS = 'FETCH_IRONING_PACKING_DC_DETAILS_SECOND_GRID_SUCCESS';
export const FETCH_IRONING_PACKING_DC_DETAILS_SECOND_GRID_FAILURE = 'FETCH_IRONING_PACKING_DC_DETAILS_SECOND_GRID_FAILURE';

export const IRONING_PACKING_DC_PROGRAM_ID_REQUEST = 'IRONING_PACKING_DC_PROGRAM_ID_REQUEST';
export const IRONING_PACKING_DC_PROGRAM_ID_SUCCESS = 'IRONING_PACKING_DC_PROGRAM_ID_SUCCESS';
export const IRONING_PACKING_DC_PROGRAM_ID_FAILURE = 'IRONING_PACKING_DC_PROGRAM_ID_FAILURE';


export const CHECK_ALL_UPDATE_REQUEST_IRONING = 'CHECK_ALL_UPDATE_REQUEST_IRONING'
export const CHECK_ALL_UPDATE_SUCCESS_IRONING = 'CHECK_ALL_UPDATE_SUCCESS_IRONING'
export const CHECK_ALL_UPDATE_FAILURE_IRONING = 'CHECK_ALL_UPDATE_FAILURE_IRONING'

export const DELETE_CUTTING_DC_REQUEST_CALL_OFF = 'DELETE_CUTTING_DC_REQUEST_CALL_OFF'
export const DELETE_CUTTING_DC_SUCCESS_CALL_OFF = 'DELETE_CUTTING_DC_SUCCESS_CALL_OFF'
export const DELETE_CUTTING_DC_FAILURE_CALL_OFF = 'DELETE_CUTTING_DC_FAILURE_CALL_OFF'

export const IRONING_DC_WITH_ACC_REQUEST = 'IRONING_DC_WITH_ACC_REQUEST';
export const IRONING_DC_WITH_ACC_SUCCESS = 'IRONING_DC_WITH_ACC_SUCCESS';
export const IRONING_DC_WITH_ACC_FAILURE = 'IRONING_DC_WITH_ACC_FAILURE';

export const IRONING_AND_PACKING_DC_WITH_ACC_REQUEST = 'IRONING_AND_PACKING_DC_WITH_ACC_REQUEST';
export const IRONING_AND_PACKING_DC_WITH_ACC_SUCCESS = 'IRONING_AND_PACKING_DC_WITH_ACC_SUCCESS';
export const IRONING_AND_PACKING_DC_WITH_ACC_FAILURE = 'IRONING_AND_PACKING_DC_WITH_ACC_FAILURE';

export const CREATE_USER_FORM_IRONING_WITH_ACC_GENERATE_QTY = 'CREATE_USER_FORM_IRONING_WITH_ACC_GENERATE_QTY';

export const CREATE_IRONING_DC_WITH_ACC_REQUEST = 'CREATE_IRONING_DC_WITH_ACC_REQUEST';
export const CREATE_IRONING_DC_WITH_ACC_SUCCESS = 'CREATE_IRONING_DC_WITH_ACC_SUCCESS';
export const CREATE_IRONING_DC_WITH_ACC_FAILURE = 'CREATE_IRONING_DC_WITH_ACC_FAILURE';

export const RESET_TO_IRONING_ACC_PERVIOUS_LIST = 'RESET_TO_IRONING_ACC_PERVIOUS_LIST';

export const DELETE_IRONING_PACKING_DC_REQUEST = 'DELETE_IRONING_PACKING_DC_REQUEST';
export const DELETE_IRONING_PACKING_DC_SUCCESS = 'DELETE_IRONING_PACKING_DC_SUCCESS';
export const DELETE_IRONING_PACKING_DC_FAILURE = 'DELETE_IRONING_PACKING_DC_FAILURE';

export const DELETE_IRONING_PACKING_DC_ACC_REQUEST = 'DELETE_IRONING_PACKING_DC_ACC_REQUEST';
export const DELETE_IRONING_PACKING_DC_ACC_SUCCESS = 'DELETE_IRONING_PACKING_DC_ACC_SUCCESS';
export const DELETE_IRONING_PACKING_DC_ACC_FAILURE = 'DELETE_IRONING_PACKING_DC_ACC_FAILURE';


